/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { makeVar } from '@apollo/client';

import { IModal } from '@fluentui/react/lib/Modal';
import { AdminGroupState } from '../../service/gen/templates';
import { Template } from '../../utilities/TemplateUtils';

export enum TemplateScope {
    TenantAll = 'TenantAll',
    TenantSpecificPeople = 'TenantSpecificPeople',
    Team = 'Team',
    None = 'None',
}

export type TeamBasicInfo = {
    id: string;
    name: string;
};

export type TemplateManagementListScope = {
    scope: TemplateScope;
    team?: TeamBasicInfo;
};

export const currentScopeInListVar = makeVar<TemplateManagementListScope>({ scope: TemplateScope.None });

export enum ModalType {
    PreSetupWizard,
    PreviewTemplateInstance,
    ChangeTemplateInstanceIcon,
}

export type ModalData = {
    isOpen: boolean;
    type?: ModalType;
    template?: Template;
};

export const modalDataVar = makeVar<ModalData>({ isOpen: false });

export const modalRefVar = makeVar<React.MutableRefObject<IModal>>(null);

export const currentScopeInCreationVar = makeVar<TemplateScope>(TemplateScope.None);

export const currentTeamInCreationVar = makeVar<TeamBasicInfo>(null);

// *Set undefined(flag) to represent not communicate with server yet
export const currentAdminGroupStateVar = makeVar<AdminGroupState>(AdminGroupState.Unknown);

export const currentTemplateVar = makeVar<Template>(null);

export const resetPreSetupTemplateVars = (): void => {
    currentScopeInCreationVar(TemplateScope.None);
    currentTemplateVar(null);
    currentTeamInCreationVar(null);
};

// Vars of user identity for access control.
export const isAdminVar = makeVar<boolean | undefined>(undefined);
export const isTeamOwnerVar = makeVar<boolean | undefined>(undefined);

// ReactiveVar for the state of template management coach mark. By ReactiveVar other coachmark can get its state and
// determine if they should show.
export const showTemplateManagementCoachButtonMark = makeVar<boolean>(false);

export type ShareTemplateRequestDialogData = {
    isOpen: boolean;
    templateDefinitionId?: string;
    templateDefinitionTitle?: string;
    templateAccessText?: string;
    templateAllowAnyoneSubmission?: boolean;
    onCopyClick?: () => void;
};

export const shareTemplateRequestDialogDataVar = makeVar<ShareTemplateRequestDialogData>({ isOpen: false });
